import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import homebanner from "../../../assets/images/main_bgItem.png";
import pckthree from "../../../assets/images/packthree.png";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
// import Carousel from 'react-bootstrap/Carousel';
// import ExampleCarouselImage from 'components/ExampleCarouselImage';
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Img } from 'react-image';
import Slider from "../MySlider";
import './styles.css';
import { Box, CircularProgress, LinearProgress } from "@mui/material";

const Sec1 = () => {

	const navigate = useNavigate();

	const [slides, setSlides] = useState([]);
	const [sliderId, setSliderId] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [isSliderText, setIsSliderText] = useState(false);
	const [images, setImages] = useState([]);

	const target_images = slides?.map((e) => e.image);
	// useEffect(() => {
	// 	if (target_images) {
	// 		// Simulate a delay in fetching images
	// 		setTimeout(() => setImages(target_images), 1000);
	// 	}
	// }, [target_images]);

	useEffect(() => {
		getSlides()
	}, [])
	const getSlides = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"slider",
			"fetchSlider",
			{},
			(res) => {
				const id = res.data?.data?.sliders[0]?.id;
				const isShowTxt = res.data?.data?.sliders[0]?.is_show_text;
				setSliderId(id);
				setIsSliderText(isShowTxt);


				if (id) {

					CoreHttpHandler.request(
						"slider",
						"fetchSlides",
						{
							is_modal:false,
							id: id,
						},
						(res) => {
							setSlides(res.data.data.slides);
							setIsLoading(false); // Ensure loading state is set to false even on error

						},
						(err) => {
							// ToastAlertError(
							// 	err?.response?.data?.message
							// 		? err?.response.data.message
							// 		: "something went wrong"
							// );
						}
					);

				}
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};
	return (
		<>



			{slides.length > 0 ? (
				<Slider isSliderText={isSliderText} data={slides} />
			) : (
				<Box sx={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
					<CircularProgress color="success" />
				</Box>
			)}
			{/* <section className='sec sec1'>
				<div className='container'>
					<div className='inner_wrap'>
						<div className='col'>
							<h1>
								<span>
									Enhancing Shareholder
								</span>
								<span className="bold" style={{ color: "#07588f" }}>
								{" "}Knowledge,
								</span>
								<span className="bold" style={{ color: "#16b2b0" }}>
								{" "}Fostering
									Engagement
								</span>
								<span className="bold" style={{ color: "#000000" }}>
									{" "}& Empowering
								</span>
							</h1>
							<Button onClick={()=>navigate("/ShareHoldersRights/Documents")} className="btn1" variant="primary">Know your rights as a shareholders</Button>
							
						</div>
						<div className='col'>
							<img
								src={homebanner}
								className='banner_img'
								alt='no'
								loading='lazy'
							/>
							
						</div>
					</div>
				</div>
			</section> */}
		</>
	);
};

export default Sec1;
